export const LINE_BREAK_REGEX = /(\r\n|\r|\n)/

export const FALLBACK_LANG = "en"

/**
 * @deprecated
 */
export const CRONOFY_WIDGET = {
    AvailabilityRules: "AvailabilityRules",
    AvailabilityViewer: "AvailabilityViewer",
    CalendarSync: "CalendarSync"
} as const

const ONE_MINUTE_STALE_TIME = 60000

export { ONE_MINUTE_STALE_TIME }
